import service from "@/utils/request"

export function getAccountInfo(params) {
    return service({
        url: '/partnerAccountApi/getAccountInfo',
        method: 'get',
        params
    })
}




